<template>
  <div class="category">
    <searchTag
      :type="type"
      :topic="topic"
      :job="job"
      :sex="sex"
      ref="tag"
      @getList="getList"
      @getArea='getArea'
    />
    <main class="margint32">
      <header class="flex_r_between">
        <div class="num f16 line22">共计{{ num }}个档案</div>
        <div>
          <div class="sort flex_r">
            <span :class="[sort==0&&'active']" @click="setSort('0')">默认排序</span>
            <span :class="[sort==1&&'active']" @click="setSort('1')">按点击量倒序</span>
          </div>
        </div>
      </header>
      <div class="pt40">
        <myVideo :videoArr="list" />
      </div>
    </main>
    <myPagination
      @prevClick="prevClick"
      @nextClick="nextClick"
      @currentChange="currentChange"
      :page_count="page_count"
    />
  </div>
</template>
<script>
export default {
  name: "category",
  data() {
    return {
      type: 0,
      sex: 0,
      topic: 0,
      job: 0,
      page: 1,
      list: [],
      page_count: 1,
      kw: "",
      sort: 0,
      city: 0,
      province: 0,
      num: 0,
    };
  },
  watch: {
    $route(newv, oldv) {
      if (newv) {
        this.kw = newv.query.kw;
        this.getData();
      }
    },
  },
  mounted() {
    if (this.$route.query.kw) {
      this.kw = this.$route.query.kw;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.getData();
  },
  methods: {
    getArea(data){
      this[data.key] = data.val > 0 ? data.val : 0;
      if(data.key == 'province'&&data.val < 0){
        this.city = 0;
        this.page = 1;
        this.list = [];
        this.getData();
      }
      if(data.key == 'city'){
        this.getData();
      }
    },
    prevClick() {
      if (this.page > 1) {
        this.page -= 1;
        this.getData();
      }
    },
    nextClick() {
      if (this.page < this.page_count) {
        this.page += 1;
        this.getData();
      }
    },
    currentChange(v) {
      this.page = v;
      this.getData();
    },
    async getList({ tagType, inx }) {
      if (inx == -1) {
        this[tagType] = 0;
      } else {
        this[tagType] = this.$refs.tag[tagType + "Arr"][inx].id;
      }
      this.page = 1;
      this.list = [];
      this.getData();
    },
    setSort(inx) {
      if (this.sort == inx) return;
      this.sort = inx;
      this.getData();
    },
    async getData() {
      let { data } = await this.$http(this.$api.daList, {
        params: {
          page: this.page,
          kw: this.kw,
          type: this.type,
          topic: this.topic,
          job: this.job,
          sex: this.sex,
          province: this.province,
          city: this.city,
          sort: this.sort,
        },
      });
      this.list = data.list;
      this.num = data.num;
      this.page_count = data.page_count;
    },
  },
};
</script>
<style lang="less" scoped>
.category {
  width: 1184px;
}

.sort {
  span {
    padding: 0 8px;
    height: 24px;
    font-size: 16px;
    line-height: 23px;
    cursor: pointer;
    box-sizing: border-box;
    color: #403333;
    margin-left: 8px;
    border: 1px solid #403333;
    &.active {
      color: #ad2729;
      border: 1px solid #ad2729;
    }
  }
}
</style>